import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuotesInvoices = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5833 17.5H5.41667C4.49583 17.5 3.75 16.7542 3.75 15.8333V4.16667C3.75 3.24583 4.49583 2.5 5.41667 2.5H14.5833C15.5042 2.5 16.25 3.24583 16.25 4.16667V15.8333C16.25 16.7542 15.5042 17.5 14.5833 17.5Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0341 4.89587C9.97662 4.89587 9.92996 4.94254 9.93079 5.00004C9.93079 5.05754 9.97746 5.10421 10.035 5.10421C10.0925 5.10421 10.1391 5.05754 10.1391 5.00004C10.1391 4.94254 10.0925 4.89587 10.0341 4.89587",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.66663 7.50004H13.3333",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8333 10V15",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3333 12.5H6.66663",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.66663 10H13.3333V15H6.66663V10Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgQuotesInvoices;
